<template>
  <div>
        <el-card >
          <el-table :data="interimAPList" >
            <el-table-column prop="id" label="ID" width="50"></el-table-column>
            <el-table-column prop="serviceProvider" :label="$t('msg.rate.quoteFrom')" align="center"></el-table-column>
            <el-table-column prop="client" :label="$t('msg.rate.quoteTo')" align="center"></el-table-column>
            <el-table-column prop="orderSector" :label="$t('msg.rate.quoteType')" align="center"></el-table-column>
            <el-table-column prop="csopName" :label="$t('msg.rate.csopName')" align="center"></el-table-column>
            <el-table-column prop="createTime" :label="$t('msg.rate.createTime')" align="center"></el-table-column>
            <el-table-column prop="payTerm" :label="$t('msg.rate.payTerm')" align="center"></el-table-column>
            <el-table-column prop="shipStatus" :label="$t('msg.account.shipStatus')" align="center"></el-table-column>
            <el-table-column prop="billStatus" :label="$t('msg.account.billStatus')" align="center"></el-table-column>
            <el-table-column fixed="right" :label="$t('msg.rate.Operations')" width="200px" align="center">
              <template #default="{row}">
                <el-button type="primary" size="small" @click="getDetail(row)">{{ $t('msg.excel.show') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
export default defineComponent({
  name: 'interimAP',
  setup() {
    const router = useRouter()
    const interimAPList = ref()
    const curUser = localStorage.getItem('curUser')
    onMounted(() => {
      const param = 'curName=' + curUser
      const reqURL = process.env.VUE_APP_BASE + '/getMyInterimAP'
      axios.post(reqURL, param).then((response) => {
        interimAPList.value = response.data
      }).catch((response) => {
        console.log(response)
      })
    })
    const getDetail = row => {
      const myParam = 'myNewId=' + row.id + '&orderSector=' + row.orderSector + '&curName=' + curUser + '&billType=AP'
      router.push(`/Billing/editTemp/${myParam}`)
    }
    return { interimAPList, getDetail }
  }
})
</script>
